import { isNaN } from 'lodash';

const DEFAULT_PRECISION = 6;

export function precision(value: string | number, digits = DEFAULT_PRECISION): string {
  if (typeof value === 'string' && (value.includes('e') || value.includes('E'))) {
    return value.toLowerCase();
  }

  const numVal = typeof value === 'string' ? parseFloat(value) : value;

  if (isNaN(numVal)) {
    return `${value}`;
  }

  return removeTrailingZeros(numVal.toPrecision(digits)).toLowerCase();
}

function removeTrailingZeros(str: string) {
  // if no decimal or scientific notation used, return unchanged
  if (!str.includes('.') || str.includes('e') || str.includes('E')) {
    return str;
  }

  //  remove trailing zeros
  str = str.replace(/0+$/, '');

  // if number ends with decimal, remove it too
  if (str.charAt(str.length - 1) === '.') {
    str = str.slice(0, -1);
  }

  return str;
}
